var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowIntegrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#323232"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_1602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_1602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7779 55H27.7779C27.0279 55 26.3774 54.7246 25.8263 54.1737C25.2754 53.6226 25 52.9721 25 52.2221V45.2221C26.2592 45.1296 27.3471 44.669 28.2638 43.8404C29.1804 43.0115 29.6388 41.9814 29.6388 40.75C29.6388 39.5186 29.1804 38.4885 28.2638 37.6596C27.3471 36.831 26.2592 36.3704 25 36.2779V29.2779C25 28.5279 25.2754 27.8774 25.8263 27.3263C26.3774 26.7754 27.0279 26.5 27.7779 26.5H34.9167C35.1203 25.3703 35.6203 24.4212 36.4167 23.6529C37.2131 22.8843 38.176 22.5 39.3054 22.5C40.4351 22.5 41.3982 22.8843 42.1946 23.6529C42.9907 24.4212 43.4907 25.3703 43.6946 26.5H50.7221C51.4721 26.5 52.1226 26.7754 52.6737 27.3263C53.2246 27.8774 53.5 28.5279 53.5 29.2779V36.3054C54.6297 36.5093 55.5649 37.0279 56.3054 37.8612C57.0463 38.6946 57.4167 39.676 57.4167 40.8054C57.4167 41.9351 57.0463 42.8843 56.3054 43.6529C55.5649 44.4213 54.6297 44.9074 53.5 45.1113V52.2221C53.5 52.9721 53.2246 53.6226 52.6737 54.1737C52.1226 54.7246 51.4721 55 50.7221 55H43.7221C43.6296 53.6481 43.1551 52.5369 42.2987 51.6667C41.4421 50.7964 40.4258 50.3612 39.25 50.3612C38.0742 50.3612 37.0579 50.7964 36.2013 51.6667C35.3449 52.5369 34.8704 53.6481 34.7779 55ZM27.7779 52.2221H32.5696C33.2546 50.4815 34.2582 49.2732 35.5804 48.5971C36.9024 47.9212 38.1246 47.5833 39.2471 47.5833C40.3693 47.5833 41.5925 47.9212 42.9167 48.5971C44.2408 49.2732 45.2454 50.4815 45.9304 52.2221H50.7221V42.3613H53.0833C53.5278 42.3613 53.8982 42.2131 54.1946 41.9167C54.4907 41.6203 54.6388 41.2499 54.6388 40.8054C54.6388 40.361 54.4907 39.9907 54.1946 39.6946C53.8982 39.3982 53.5278 39.25 53.0833 39.25H50.7221V29.2779H40.8613V26.8333C40.8613 26.3889 40.7131 26.0185 40.4167 25.7221C40.1203 25.426 39.7499 25.2779 39.3054 25.2779C38.861 25.2779 38.4907 25.426 38.1946 25.7221C37.8982 26.0185 37.75 26.3889 37.75 26.8333V29.2779H27.7779V34.1112C29.1696 34.6263 30.2906 35.489 31.1408 36.6996C31.9914 37.9101 32.4167 39.2624 32.4167 40.7563C32.4167 42.2243 31.9907 43.5649 31.1387 44.7779C30.2871 45.9907 29.1668 46.861 27.7779 47.3887V52.2221Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowIntegrations);
export default __webpack_public_path__ + "static/media/icon-flow-integrations.dd6fb2615dea4e1543028e19bf60468c.svg";
export { ForwardRef as ReactComponent };